import { render, staticRenderFns } from "./upload-volunteer.vue?vue&type=template&id=59ea5aa7&scoped=true"
import script from "./upload-volunteer.vue?vue&type=script&lang=js"
export * from "./upload-volunteer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ea5aa7",
  null
  
)

export default component.exports